const getRiskState = (state) => state.risk;

export const getSeverityList = (state) => {
  const _state = getRiskState(state);
  return _state.SeverityList;
};

export const getRiskStatusList = (state) => {
  const _state = getRiskState(state);
  return _state.StatusList;
};

export const getDecisionList = (state) => {
  const _state = getRiskState(state);
  return _state.DecisionList;
};

export const getCurrentRisk = (state) => {
  const _state = getRiskState(state);
  return _state.currentRisk;
};

export const getRatingsTypes = (state) => {
  const _state = getRiskState(state);
  return _state.RatingsTypes;
};

export const isRiskCompleted = (riskStatusList, status) => {
  const riskStatus = riskStatusList.find((s) => s.id.toLowerCase() === status.toLowerCase());
  return riskStatus ? riskStatus.isCompleted : false;
};
